<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<mat-card class="block" [attr.aria-busy]="loading">
  <h2>Participants</h2>
  <form class="actions" (ngSubmit)="find()">
    <mat-form-field appearance="outline">
      <mat-label>Search by name, learner ID or team</mat-label>
      <input matInput name="search" [(ngModel)]="search">
    </mat-form-field>
    <button mat-button type="submit" [disabled]="loading">Search</button>
  </form>
  <div *ngIf="error" role="alert">
    <p>{{ error }}</p>
    <button mat-button type="button" (click)="load()">Retry</button>
  </div>
  <ng-container *ngIf="!loading && !error">
    <p aria-live="polite">{{ totalCount }} {{ search.trim() ? 'matching participants' : 'participants' }}</p>
    <div class="list" *ngIf="participants.length; else empty">
      <div class="row" *ngFor="let participant of participants">
        <div>
          <strong>{{ participant.displayName || 'Unnamed learner' }}</strong>
          <div class="meta">Learner ID: {{ participant.userId }}</div>
          <div class="meta">Email: {{ participant.email || 'Not provided' }}</div>
          <div class="meta">Phone: {{ participant.phoneNumber || 'Not provided' }}</div>
          <div class="meta">Joined {{ participant.registeredAt | date:'medium' }}</div>
          <div class="meta">Team: {{ participant.teamName || 'No team' }}</div>
        </div>
      </div>
    </div>
    <ng-template #empty><p class="empty">{{ search.trim() ? 'No participants match your search.' : 'No participants registered yet.' }}</p></ng-template>
  </ng-container>
  <mat-paginator *ngIf="!error" [length]="totalCount" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 25, 50, 100]" (page)="changePage($event)" aria-label="Participants pagination"></mat-paginator>
</mat-card>
